import { Injectable } from '@angular/core';

import { UserSettingsSpeech } from '@shared/models';
import { OrUserSettingsService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpeechSettingsResolver {
  constructor(private userSettingsService: OrUserSettingsService) {}

  resolve(): Observable<UserSettingsSpeech> {
    return this.userSettingsService.loadSpeechSettings();
  }
}
